export const getAnalyticsTarget = ({ title, buttonText }) => {
  return `${(title || '').toLowerCase()}|${(buttonText || '').toLowerCase()}`;
};

export const publishAnalyticsEvent = (thdAnalyticsEvent) => {
  window.digitalData = window.digitalData || {};
  window.digitalData.event = window.digitalData.event || [];
  window.digitalData.event.push(thdAnalyticsEvent);
};

export const publishPipCalloutEvent = ({ title, buttonText }) => {
  publishAnalyticsEvent({
    category: {
      primaryCategory: 'interaction'
    },
    eventInfo: {
      eventName: 'pip sub-content'
    },
    subContent: {
      component: 'button',
      section: 'pip callout',
      target: getAnalyticsTarget({ title, buttonText })
    }
  });
};
